import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import { PrimaryButton } from 'component-library';
import { useNavigate } from 'react-router-dom';

export const SettingsCustomers = () => {
  const navigate = useNavigate();

  return (
    <div className='flex flex-col pt-16'>
      <h4 className='prose-heading4 pb-2'>Customers</h4>
      <p className='prose-paragraphBase text-gray-60 max-w-[52ch] mb-3'>
        Add your customers to the portal.
        <br />
        <br />
        With this feature you can create separate customer accounts that systems can be assigned to. These indirect
        customers can use all the portals features on systems assigned to them. Upgrades will have to be invoiced from
        you to your customer, use the order tab to overview orders.
        <br />
        <br />
        For more support, contact your Humphree representative if you are interested in how this feature works and wants
        to set it up.
      </p>
      <PrimaryButton
        icon={faPlus}
        label='Add customer'
        onClick={() => {
          navigate('/create/customer/');
        }}
      />
    </div>
  );
};
